import { ConversationModel } from '@klant/conversational-connector/models/Conversation.model';
import { ConversationResponse } from '@fp/interfaces/conversational/generated/model/conversation-response';
import { ChatMessageModel } from '@klant/conversational-connector/models/ChatMessage.model';
import { ConversationResponseConversationMessagesInner } from '@fp/interfaces/conversational/generated/model/conversation-response-conversation-messages-inner';
import { ChatModelMapper } from '@klant/conversational-connector/mappers/chat-model-mapper/chat-model.mapper';

import { Injectable } from '@angular/core';

/**
 * @module KlantConversationalModule
 * @ngdoc mapper-service
 * @name ChatModelMapper
 */
@Injectable({ providedIn: 'root' })
export class ConversationMapper {
    public static mapConversationResponseToConversationModel(conversationResponse: ConversationResponse): ConversationModel {
        const conversation = conversationResponse.conversation;

        return {
            chatMessages: this.mapMessagesToChatMessagesModel(conversation.messages),
            accessToken: conversation.accessToken,
            resumeConversationPrompt: conversation.ui.resumeConversationPrompt,
            webSocketLink: conversationResponse._links.socket.href,
            conversationLink: conversationResponse._links.conversation.href
        };
    }

    private static isNotInfo = (message: ConversationResponseConversationMessagesInner): boolean => message.type !== 'info';

    private static isParticipantWithIntroOrOther(message: ConversationResponseConversationMessagesInner): boolean {
        return message.type !== 'participant' || !!message.payload.participant.introduction;
    }

    private static readonly isNotImage = (message: ConversationResponseConversationMessagesInner): boolean =>
        !(message.type === 'message' && message.payload.type === 'image');

    private static readonly isNotCard = (message: ConversationResponseConversationMessagesInner): boolean =>
        !(message.type === 'message' && message.payload.type === 'card');

    private static mapMessagesToChatMessagesModel(messages: ConversationResponseConversationMessagesInner[]): ChatMessageModel[] {
        return messages
            .filter(this.isNotInfo)
            .filter(this.isNotImage)
            .filter(this.isNotCard)
            .filter(this.isParticipantWithIntroOrOther)
            .map((message) => ChatModelMapper.mapMessageToChatMessageModel(message))
            .filter((mappedMessage) => mappedMessage !== null)
            .sort((a, b) => a.occurredAt - b.occurredAt);
    }
}
